// themes
import paleteDark from './paleteDark';
import paleteLight from './paleteLight';

// theme images
// import mapDark from '#assets/mapDark.svg';
// import mapLight from '#assets/mapLight.svg';
// import alertDark from '#assets/alertDark.svg';
// import alertLight from '#assets/alertLight.svg';

export const getDesignTokens = (mode) => ({
  images: {
    ...(mode === 'light'
      ? {
        //   alert: alertDark,
        //   map: mapDark,
      }
      : {
        //   alert: alertLight,
        //   map: mapLight,
      }),
  },
  palette: {
    mode,
    ...(mode === 'dark' && paleteDark),
    ...(mode === 'light' && paleteDark),// paleteLight),
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.2rem',
      lineHeight: 1.2,
    },
    h2: {
      fontWeight: 700,
      fontSize: '2.1rem',
      lineHeight: 1.2,
    },
    h3: {
      fontWeight: 700,
      fontSize: '1.8rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    subtitle1: {
      fontSize: '1.1rem',
      color: '#e3e3e3ff',
    }
  },
});
